import { Command } from 'commands/Commands';

export class ChangeEnableScripts extends Command {
  priority: number = 100;
  type: string = 'ChangeEnableScripts';
}
